import React from 'react';
import PropTypes from 'prop-types';
import cloneDeep from 'lodash/cloneDeep';
import {Footer as MastheadFooter} from '@spotify-internal/masthead-react';

import {configPropType, marketInfoPropType} from 'utils/custom-proptypes';
import {SPOTIFYCOM_URL} from 'lib/shared/config/config';
import withTranslation from 'lib/shared/i18n/withTranslation';
import {withConfig} from 'context/Config/ConfigProvider';
import {withMarketInfo} from 'context/MarketInfo/MarketInfoProvider';

const FALLBACK_DATA = {
  brand: {
    href: SPOTIFYCOM_URL,
    alt: 'Spotify',
  },
  topLinkGroups: [],
  socialLinks: [],
  bottomLinks: [],
  country: {
    name: 'Select country',
    flagCode: 'gb',
    href: `${SPOTIFYCOM_URL}/select-your-country`,
  },
  copyrightNotice: `© ${new Date().getFullYear()} Spotify AB`,
};

const Footer = ({t, footerData = FALLBACK_DATA, config, marketInfo}) => {
  const {supportSiteUrl, plainUI} = config;
  const {locale} = marketInfo;

  if (plainUI) {
    return null;
  }

  const topLinkGroups = cloneDeep(footerData.topLinkGroups);

  // Add our custom Contact us link for en-US markets
  if (locale === 'en-US' && topLinkGroups.length) {
    topLinkGroups[topLinkGroups.length - 1].links.push({
      title: t('contact_spotify'),
      href: supportSiteUrl('/article/how-can-i-contact-spotify/?in_footer'),
    });
  }

  return <MastheadFooter {...footerData} topLinkGroups={topLinkGroups} />;
};

Footer.propTypes = {
  t: PropTypes.func.isRequired,
  marketInfo: marketInfoPropType,
  config: configPropType,
  footerData: PropTypes.object,
};

export default withTranslation()(withMarketInfo(withConfig(Footer)));
